import API, {APIRequestConfig} from "../API"
import setIfNotSet from "../../setIfNotSet"
import channel from "../../channel"
import version from "../../version"
import setOperationNameToParams from "./utils/setOperationNameToParams"
import appendApolloClientValues from "./utils/appendApolloClientValues"
import {PB_FEATURES} from "./helpers/features"

/** @author: Richard Scoones 22/8/2018
 * @desc: Used by apollo to make requests instead of fetch
 */
export default function (overrides: APIRequestConfig = {}) {
  return {
    async request(config: APIRequestConfig = {}) {
      setIfNotSet(config, "isApolloQuery", true)
      setIfNotSet(config, "headers.x-pb-features", PB_FEATURES)
      setIfNotSet(config, "headers.x-pb-channel", channel)
      setIfNotSet(config, "headers.x-pb-version", version)

      // Pass file upload flag from overrides to config
      if (overrides.isFileUpload) {
        setIfNotSet(config, "headers.apollo-require-preflight", true)
      }
      if (overrides.isAndroidFileUpload) {
        config.isAndroidFileUpload = true
      }

      // Add non-functional query param of the operation name
      setOperationNameToParams(config)
      await appendApolloClientValues(config)

      return API.request({...config, ...overrides})
    }
  }
}
